export class Loinc {
    static loincValues: Array<string> =
        [
            "94306-8",
            "94307-6",
            "94308-4",
            "94309-2",
            "94310-0",
            "94311-8",
            "94312-6",
            "94313-4",
            "94314-2",
            "94315-9",
            "94316-7",
            "94500-6",
            "94502-2",
            "94503-0",
            "94504-8",
            "94505-5",
            "94506-3",
            "94507-1",
            "94508-9",
            "94509-7",
            "94510-5",
            "94511-3",
            "94531-1",
            "94532-9",
            "94533-7",
            "94534-5",
            "94547-7",
            "94558-4",
            "94559-2",
            "94562-6",
            "94563-4",
            "94564-2",
            "94565-9",
            "94639-2",
            "94640-0",
            "94641-8",
            "94642-6",
            "94643-4",
            "94644-2",
            "94645-9",
            "94646-7",
            "94647-5",
            "94660-8",
            "94661-6",
            "94720-0",
            "94745-7",
            "94746-5",
            "94756-4",
            "94757-2",
            "94758-0",
            "94759-8",
            "94760-6",
            "94761-4",
            "94762-2",
            "94763-0",
            "94764-8",
            "94765-5",
            "94766-3",
            "94767-1",
            "94768-9",
            "94769-7",
            "94819-0",
            "94822-4",
            "94845-5",
            "95125-1",
            "95209-3",
            "95380-2",
            "95406-5",
            "95409-9",
            "95410-7",
            "95411-5",
            "95416-4",
            "95422-2",
            "95423-0",
            "95424-8",
            "95425-5",
            "95427-1",
            "95428-9",
            "95429-7",
            "95521-1",
            "95522-9",
            "95542-7",
            "95608-6",
            "95609-4",
            "95823-1",
            "95824-9",
            "95825-6",
            "95826-4",
            "95941-1",
            "95942-9",
            "95970-0",
            "95971-8",
            "95972-6",
            "95973-4",
            "95974-2",
            "96091-4",
            "96094-8",
            "96118-5",
            "96119-3",
            "96120-1",
            "96121-9",
            "96122-7",
            "96123-5",
            "96448-6",
            "96603-6",
            "96741-4",
            "96742-2",
            "96751-3",
            "96752-1",
            "96755-4",
            "96763-8",
            "96764-6",
            "96765-3",
            "96766-1",
            "96797-6",
            "96829-7",
            "96894-1",
            "96895-8",
            "96896-6",
            "96897-4",
            "96898-2",
            "96899-0",
            "96900-6",
            "96957-6",
            "96958-4",
            "96986-5",
            "97097-0",
            "97098-8",
            "97099-6"
        ];
}